export const ActivitiesData = [
  {
    title: "Fine Motor Activities",
    description: `Here are some fun fine motor activities for preschoolers:`,
    activityDetails: [
      { title: 'Playdough Shapes', details: 'Children can use playdough to create different shapes, letters, or animals. This strengthens their finger muscles and encourages creativity.' },
      { title: 'Cutting Practice', details: 'Offer child-safe scissors and paper with pre-drawn lines or shapes for children to cut out, helping to develop precision and control.' },

      {
        title: 'Puzzles', details: "Age-appropriate puzzles help improve fine motor control while engaging children's problem-solving skills."
      },
      {
        title: 'Clothespin Pinching',
        details: "Let children practice squeezing and pinching clothespins onto a string or edge of a box. This helps build finger strength."
      },
      {
        title: 'Paper Tearing',
        details: "Encourage children to tear paper into strips or shapes. It's a great way to strengthen hand muscles and improve coordination."
      },
      {
        title: 'Pom-Pom Transfer',
        details: "Using a spoon, children can transfer pom-poms from one bowl to another. This enhances hand stability and grip control."
      },
      {
        title: 'Finger Painting',
        details: "Let kids paint using their fingers instead of brushes. It's a fun, sensory way to develop hand dexterity while being creative."
      },
      {
        title: 'Hole Punching',
        details: "Provide a hole puncher and paper for children to punch holes. It's an excellent way to strengthen hand muscles."
      },
      {
        title: 'Peeling Tape',
        details: "Stick pieces of masking tape on a table and let kids peel them off. This helps with finger control and grip."
      },
      {
        title: 'Dot Marker Art',
        details: "Give kids dot markers to create art on a page. It requires control and improves hand strength as they press and dot."
      },
      {
        title: 'Pipe Cleaner Creations',
        details: "Let kids bend and twist pipe cleaners to create shapes, letters, or simple objects. This develops fine motor strength and creativity."
      },
      {
        title: 'Threading Pasta',
        details: "Let children thread dry pasta onto a string or pipe cleaner. It’s great for hand-eye coordination and fine motor precision."
      },
      {
        title: 'Sponge Squeezing',
        details: "In a water play activity, let kids squeeze water out of sponges. This helps strengthen their hand muscles."
      },
      {
        title: 'Cat Eats Beans',
        details: "In this imaginative fine motor activity, children pretend to feed a toy cat beans using a spoon. The act of scooping and carefully feeding the 'cat' enhances hand-eye coordination, grip strength, and control. It's a fun way to develop fine motor skills while engaging in pretend play."
      },
      {
        title: 'Peek-a-Boo',
        details: "In this fine motor activity, children use a toy hammer to tap objects that 'pop up' in a peek-a-boo style game. The hammering action helps develop hand-eye coordination, precision, and grip strength, making it a playful and engaging way to build fine motor skills."
      },


    ],

    images: [
      {
        title: 'Pipe cleaner',
        path: "https://lh3.googleusercontent.com/d/1Ti0DS9owEqr8prE0wrbocLKR_hFSLLvj=s1000?authuser=0",
      },
      {
        title: 'Transffering activity',
        path: "https://lh3.googleusercontent.com/d/1yeV22kI1iarVrIw02Xh8yX_0_9xlYRGU=s1000?authuser=0",
      },
      {
        title: 'Peeka boo',
        path: "https://lh3.googleusercontent.com/d/1dciazxwMRE6jT5JYFldCAILAsu5_vA9P=s1000?authuser=0",
      },
      {
        title: 'Cotton ball sheep',
        path: "https://lh3.googleusercontent.com/d/1Yum1QLsKCtE1bFqY1yQ6jNaIwqQlPO8F=s1000?authuser=0",
      },
      {
        title: 'Color Matching',
        path: "https://lh3.googleusercontent.com/d/1WFqFjY77tm3WFu_ZrXnjL0oz8-Bt9H7g=s1000?authuser=0",
      },
      {
        title: 'Fishing game',
        path: "https://lh3.googleusercontent.com/d/1KLPCfM3k1SYc7jgPjt7TvGKMsIhoir3F=s1000?authuser=0",
      },
      {
        title: 'Ball drop activity',
        path: "https://lh3.googleusercontent.com/d/1uALzQqYkbPCOETBTjiEfZJBJ6bdPcrE5=s1000?authuser=0",
      },
      {
        title: 'Block building',
        path: "https://lh3.googleusercontent.com/d/1IGEiPZBOKLqdA_DUDbpMivfbOL6aWRxW=s1000?authuser=0"
      }
    ],

    videos: [
      {
        title: "Pipe cleaner",
        path: `tQMUjoMI3V8`,

      },
      {
        title: "Peeka boo",
        path: `PN1fVr77js4`,

      },
      {
        title: "Feeding the chick",
        path: `a1N_DjsVmTM`,

      },
      {
        title: "Magnetic tab",
        path: `VQewR_eKbRk`,

      },
      {
        title: "Egg smashing",
        path: `6l4QHmJ_v9w`,

      },
      {
        title: "Peg activity",
        path: `MUd5-Fg0wyE`,

      },
      {
        title: "Color recognition",
        path: `GkEfAH9HvXo`,

      },

    ]
  },
  {
    title: "Gross Motor Activities",
    description: `Gross motor skills are the abilities required to control the large muscles of the body for movement and coordination. These skills involve actions like walking, running, jumping, climbing, and balancing, which help children perform everyday activities and engage in physical play. Here are some fun gross motor activities that can help build strength, coordination, and balance:`,
    images: [
      {
        title: "Sticky wall ball",
        path: "https://lh3.googleusercontent.com/d/1uWVkU_iCHaqS9ymfWCgZ7RErKoJIfroF=s1000?authuser=0",

      },
      {
        title: "Ball drop activity",
        path: "https://lh3.googleusercontent.com/d/1uALzQqYkbPCOETBTjiEfZJBJ6bdPcrE5=s1000?authuser=0",

      },
      {
        title: 'Sorting shapes',
        path: "https://lh3.googleusercontent.com/d/1xfPE_TnFyFyG6DmOu9oOU5keOUFmIYuZ=s1000?authuser=0",
      },
      {
        title: 'Two piceces Flash cards',
        path: "https://lh3.googleusercontent.com/d/18wWqQ04nJM_S_MTUB9E88cyevH_NtFEx=s1000?authuser=0",
      },
    ],
    videos: [
      {
        title: "Sticky wall ball",
        path: `hPh0NDnTb8A`,

      },
    ],
    activityDetails: [
      { title: 'Obstacle Course', details: ' Set up simple obstacles using pillows, tunnels, and cones. Encourage climbing, crawling, and jumping.' },
      { title: 'Balance Beam', details: 'Create a line on the floor with tape and let them walk along it to practice balance.' },
      { title: 'Throwing and Catching Balls', details: 'Use a soft ball to improve hand-eye coordination.' },
      { title: 'Jumping', details: 'Practice jumping over small objects or into hoops.' },
      { title: 'Climbing', details: ' Let them explore low playground structures or climbing frames.' },
      { title: 'Kicking a Ball', details: 'A great activity for learning coordination and timing.' },
      { title: 'Push and Pull Toys', details: 'Let them use toy wagons or push cars, which help develop leg and arm strength.' },
      { title: 'Balance on One Foot', details: 'A simple activity that helps improve balance and stability.' },
      { title: 'Pillow Jumping', details: 'Set up pillows in a line for them to jump over or onto, practicing control and agility.' },
      { title: 'Rolling a Ball Back and Forth', details: 'Sit on the floor and roll a ball to each other, working on arm strength and timing.' },
      { title: 'Animal Walks', details: 'Encourage them to walk like different animals – hop like a frog, waddle like a duck, or crawl like a bear.' },
    ]
  },
  {
    title: "Cognitive Skill Activities",
    description: `Cognitive development refers to the growth of a child’s ability to think, understand, reason, and remember. It involves acquiring skills like problem-solving, memory, language, attention, and decision-making, which all contribute to how a child interacts with the world. This type of development is crucial in the early years as it lays the foundation for learning and adapting as they grow. Cognitive Development Activities for Different Age Groups. For Babies and Toddlers.`,
    activityDetails: [
      { title: 'Peek-a-Boo', details: 'This classic game helps with memory and understanding object permanence (knowing things exist even when out of sight).' },
      { title: 'Sorting Colors and Shapes', details: 'Use shape sorters or colored blocks to help them recognize and categorize objects.' },
      { title: 'Cause-and-Effect Toy', details: 'Toys that respond to actions (like pressing a button to make a sound) help babies understand cause and effect.' },
      { title: 'Simple Puzzles', details: 'Age-appropriate puzzles develop problem-solving and hand-eye coordination.' },
      { title: 'Hide and Seek with Objects', details: 'Hide a toy under a cloth and encourage your child to find it, enhancing memory and tracking skills.' },
      { title: 'Matching Games', details: 'Use memory cards or picture matching to enhance memory and attention to detail.' },
      { title: 'Building with Blocks', details: 'Constructing with blocks or Legos develops spatial awareness, creativity, and fine motor skills.' },
      { title: 'Storytelling with Pictures', details: 'Use picture books to help kids identify and describe what’s happening, which builds language and comprehension.' },
      { title: 'Pretend Play', details: 'Role-playing with dolls or action figures helps kids understand social cues and practice language.' },
      { title: 'Simple Counting Games', details: 'Count toys or snacks to build early math skills.' },
    ],
    images: [
      {
        title: 'Block building',
        path: "https://lh3.googleusercontent.com/d/1IGEiPZBOKLqdA_DUDbpMivfbOL6aWRxW=s1000?authuser=0"
      },
      {
        title: 'Cotton ball sheep',
        path: "https://lh3.googleusercontent.com/d/1Yum1QLsKCtE1bFqY1yQ6jNaIwqQlPO8F=s1000?authuser=0",
      },
      // {
      //   title: 'Multiple pieces Puzzle',
      //   path: "https://lh3.googleusercontent.com/d/1SbPf7TzIplzLhNuKvf4LVR_BOqO9MYwU=s1000?authuser=0",
      // },
      {
        title: '2-pieces Puzzle',
        path: "https://lh3.googleusercontent.com/d/1Ti0DS9owEqr8prE0wrbocLKR_hFSLLvj=s1000?authuser=0",
      },
      {
        title: 'Threading pasta',
        path: "https://lh3.googleusercontent.com/d/192oSGDmWC33ASh-2mqXPFtC4FXMym_6Y=s1000?authuser=0",
      },
      {
        title: 'Sorting shapes',
        path: "https://lh3.googleusercontent.com/d/1xfPE_TnFyFyG6DmOu9oOU5keOUFmIYuZ=s1000?authuser=0",
      },
      {
        title: 'Smelling flower',
        path: "https://lh3.googleusercontent.com/d/1YZ_q07wiwupZaXby4p44zRmRoCe1pqQW=s1000?authuser=0",
      },
      {
        title: 'Fitting pipes',
        path: "https://lh3.googleusercontent.com/d/1V7jacSew1ewP67Jt1mBqCgCHY7sze4KD=s1000?authuser=0",
      },
    ],
    videos: [
      {
        title: "Peg activity",
        path: `MUd5-Fg0wyE`,

      },
      {
        title: "Water play",
        path: `M-b29wOwB0U`,

      },
      {
        title: "Busy binder",
        path: `CAoT_-vXoco`,

      },
      {
        title: "Problem solving",
        path: `A4JS7-aQAOM`,

      },
      {
        title: "Pipe joints",
        path: `4GZVOTxAuzY`,

      }

    ],
  },
  {
    title: "Language Development Activities",
    description: `Language development is the process through which children learn to communicate through sounds, words, sentences, and eventually conversation. This includes understanding and using vocabulary, grammar, and the social rules of language. Language skills are essential for self-expression, social interaction, and academic success.`,
    activityDetails: [
      { title: 'Talking and Narrating', details: 'Describe daily activities (e.g., “Now we’re putting on your shoes”) to help babies associate words with actions and objects.' },
      { title: 'Nursery Rhyme', details: 'Rhymes like “Twinkle, Twinkle, Little Star” introduce rhythm, vocabulary, and sound patterns.' },
      { title: 'Pointing and Naming Objects', details: 'Point to objects, animals, or body parts, and name them to build vocabulary.' },
      { title: 'Reading Simple Books', details: 'Choose books with bright pictures and simple text to encourage word recognition and interest in reading.' },
      { title: 'Animal Sounds', details: 'Practice saying animal sounds (e.g., “What does a cow say?”) to teach sound patterns and associations.' },
      { title: 'Storytime', details: 'Read books aloud and ask questions like “What do you think will happen next?” to develop comprehension and imagination.' },
      { title: 'Describe and Guess Game', details: 'Describe a familiar object without naming it (e.g., “It’s yellow, long, and you peel it to eat”) and let your child guess.' },
      { title: 'Role-Playing', details: 'Engage in pretend play (e.g., “Let’s play grocery store”) to encourage conversational skills, vocabulary, and sentence-building.' },
    ],
    images: [
      {
        title: 'Book reading',
        path: "https://lh3.googleusercontent.com/d/1y1R7ucgNNEbuC_Up3_hMPLNbcYWQwZHj=s1000?authuser=0"
      },
      // {
      //   title: 'Memory cards',
      //   path: "https://lh3.googleusercontent.com/d/1SbPf7TzIplzLhNuKvf4LVR_BOqO9MYwU=s1000?authuser=0"
      // },
      {
        title: 'Identifying Flash cards',
        path: "https://lh3.googleusercontent.com/d/1uALzQqYkbPCOETBTjiEfZJBJ6bdPcrE5=s1000?authuser=0"
      },
    ],
    videos: [
      {
        title: "Magnetic tab",
        path: `VQewR_eKbRk`,

      },
      {
        title: "Identifying alphabets",
        path: `oG9BLo0rf4A`,

      },
      {
        title: "Story book",
        path: `7p1TcehtzoE`,

      },
      {
        title: "Hungery cat",
        path: `Q9qw5etPZfk`,

      },
      {
        title: "Busy binder",
        path: `CAoT_-vXoco`,

      }
    ],
  },
  {
    title: "Sensory Activities",
    description: `Sensory art activities engage children’s senses—touch, sight, smell, sound, and sometimes even taste! These activities are excellent for creativity and fine motor skills, and they also provide a calming and therapeutic outlet. 
Here are some sensory art ideas suitable for toddlers and preschoolers. For Toddlers and Preschoolers`,
    activityDetails: [
      { title: 'Finger Painting', details: 'Use washable, non-toxic paint and let them explore colors and textures with their hands. For added sensory experience, you can add sand or glitter to the paint.' },
      { title: 'Edible Play Dough', details: 'Make homemade play dough (using flour, water, and food coloring) for safe, hands-on sculpting. Add scents like vanilla or cocoa powder for a sensory boost.' },
      { title: 'Ice Cube Painting', details: 'Freeze colored water in ice cube trays with popsicle sticks and use them to paint, giving a cooling, melting sensory experience.' },
      { title: 'Sensory Bins', details: 'Fill bins with items like rice, beans, pasta, or sand. Hide small toys inside for kids to find by touch.' },
      { title: 'Color Mixing in Zip Bags', details: 'Place different colors of paint in a zip-top bag, seal it, and let kids squish the bag to see colors mix.' },
      { title: 'Listening Walk', details: 'Take a walk and ask kids to identify sounds they hear, like birds chirping, cars, or leaves rustling.' },
      { title: 'Homemade Popsicles', details: 'Make fruit popsicles together, allowing them to explore flavors and textures as they eat.' },
      { title: 'Mirror Painting', details: 'Use washable paint on a mirror or shiny surface. Kids can see reflections and work with colors and shapes.' },
    ],
    images: [
      {
        title: 'Fluffy sheep',
        path: "https://lh3.googleusercontent.com/d/1Yum1QLsKCtE1bFqY1yQ6jNaIwqQlPO8F=s1000?authuser=0",
      },
      {
        title: 'Threading pasta',
        path: "https://lh3.googleusercontent.com/d/192oSGDmWC33ASh-2mqXPFtC4FXMym_6Y=s1000?authuser=0",
      },
      {
        title: 'Smelling flower',
        path: "https://lh3.googleusercontent.com/d/1YZ_q07wiwupZaXby4p44zRmRoCe1pqQW=s1000?authuser=0",
      },
      {
        title: 'Grab animals',
        path: "https://lh3.googleusercontent.com/d/1SPh5_F5ZLzQBUsHlLiIm7kQdhohRSDGr=s1000?authuser=0",
      },

    ],
    videos: [
      {
        title: "Learning shapes ",
        embed: `<iframe src="https://www.instagram.com/reel/C-fHUEGgnPz/embed" width="400" height="500" frameborder="0" scrolling="no" allowtransparency="true" allow="encrypted-media" allowfullscreen></iframe>`

      },
      {
        title: "Water play",
        path: `M-b29wOwB0U`,

      },
      {
        title: "Hungery cat",
        path: `Q9qw5etPZfk`,

      }
    ],
  }

];
